import React from 'react'

const SelectGroupedOptions = ({ optionsData }) =>
  optionsData.map(
    ({ name, items }) =>
      name && (
        <optgroup key={name} label={name}>
          {items && items.map(item => <option key={item}>{item}</option>)}
        </optgroup>
      )
  )

export default SelectGroupedOptions
